import type { SVGProps } from 'react';

export default function FileSearch2(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.85002 20.2001H6.70002C5.70591 20.2001 4.90002 19.3943 4.90002 18.4001V5.35015C4.90002 4.35603 5.70591 3.55015 6.70002 3.55015H16.15C17.1441 3.55015 17.95 4.35603 17.95 5.35015V10.7501M19.075 20.4251L17.8807 19.1923M17.8807 19.1923C18.4802 18.5831 18.85 17.7473 18.85 16.8251C18.85 14.9612 17.339 13.4501 15.475 13.4501C13.6111 13.4501 12.1 14.9612 12.1 16.8251C12.1 18.6891 13.6111 20.2001 15.475 20.2001C16.4168 20.2001 17.2685 19.8144 17.8807 19.1923ZM8.50002 7.15015H14.35M8.50002 10.7501H11.65"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
